module.exports = __webpack_public_path__ + "static/img/wealth_level_77.8df56ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_77.png
// module id = 4DsO
// module chunks = 0